import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { mergeMap } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import { Order } from '../models/order.model';
import { LocaleService } from './locale.service';

const API_URL = `${environment.flyLegacyUrl}/api`;
const ORDERS_URL = `${API_URL}/orders`;

@Injectable()
export class OrdersService {
  constructor(
    private readonly http: HttpClient,
    private readonly localeService: LocaleService
  ) {}

  getOrderInformation(orderToken: string): Observable<Order> {
    return this.localeService.getSelectedLocale().pipe(
      mergeMap((locale) => {
        const params: Record<string, any> = {};
        params.orderToken = orderToken;
        params.locale = locale.wlcLocale;
        return this.http.get<Order>(ORDERS_URL, { params });
      })
    );
  }
}
